import React from 'react';
import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,  
  Text} from '@chakra-ui/react';
import TicTacToeGame from '../../classes/TicTacToeGame';
import useCoveyAppState from '../../hooks/useCoveyAppState';
import usePlayersInTown from '../../hooks/usePlayersInTown';
import { GameResult } from '../../classes/Player';

type EndOfGameModalProps = {
  isOpen: boolean;
  closeModal: ()=>void;
  ticTacToeGame: TicTacToeGame;
}

/**
 * Modal that handles ending the game and showing game results.
 * @param param0 EndOfGameModalProps to hand in to modal
 * @returns JSX representation of the modal
 */
export default function EndOfGameModal( {isOpen, closeModal, ticTacToeGame} : EndOfGameModalProps): JSX.Element {
  const {socket, myPlayerID} = useCoveyAppState();
  const {winner, players} = ticTacToeGame;

  let winnerText;
  if (winner === 'tie') {
    winnerText = "It's a draw"
  }
  else if (winner === 'X') {
    winnerText = "Player X won!"
  }
  else if (winner === 'O') {
    winnerText = "Player O won!"
  }

  const playersInTown = usePlayersInTown();
  const currPlayer = playersInTown.find(player => player.id === myPlayerID);

  let gameResult: GameResult;
  if (winner === 'tie') {
    gameResult = 'tie';
  } else if ((myPlayerID === players.playerX && winner === 'X') || (myPlayerID === players.playerO && winner === 'O')) {
    gameResult = 'win';
  } else if ((myPlayerID === players.playerX && winner === 'O') || (myPlayerID === players.playerO && winner === 'X')) {
    gameResult = 'loss';
  } else {
    return <></>;
  }

  if (currPlayer && socket && gameResult) {
    currPlayer.updateTicTacToeStats(gameResult);
    socket.emit('onStatsUpdate', currPlayer.ticTacToeStats);
  }

  return <Modal isOpen={isOpen} onClose={()=>{closeModal(); }}><ModalContent>
  <ModalHeader>Game Over! Here are the results:  </ModalHeader>
  <ModalCloseButton />
  <ModalBody>
    <Box>{winnerText}</Box>
    <Text>If you want to play again, exit and re-enter the area!</Text>
  </ModalBody>

</ModalContent></Modal>

} 